import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { Provider } from 'react-redux'
import store from './store/store'

import "antd/dist/antd.css";
import './app.scss'

import CommonMenu from "components/common/CommonMenu";
import Home from "components/Home";
import StockAnalysis from "components/StockAnalysis/StockAnalysis";
import InvestmentPortfolio from "components/InvestmentPortfolio/InvestmentPortfolio";
import PriceList from "components/PriceList/PriceList";
import ModalViewZoom from "components/common/ModalViewZoom";
import CommonApi from "components/common/CommonApi";
import { getTokenFunction } from "firebase-config";
import { constUrlBase } from "constants/api";

require('dotenv').config()

const App: React.FC = () => {

  useEffect(() => {
    // getTokenFunction()
    // const app = app.messaging();
  }, [])

  return (
    <Provider store={store}>
      <Router>
        <CommonApi />
        <CommonMenu>
          <Switch>
            <Route path={`${constUrlBase.phan_tich_thi_truong.url}`} exact component={Home} />
            <Route path={`${constUrlBase.bang_gia.url}`} exact component={PriceList} />
            <Route path={`${constUrlBase.phan_tich_co_phieu.url}/:stock`} exact component={StockAnalysis} />
            <Route path={`${constUrlBase.phan_tich_co_phieu.url}`} exact component={StockAnalysis} />
            <Route path={`${constUrlBase.danh_muc_dau_tu.url}`} exact component={InvestmentPortfolio} />
            <Route path="/" exact component={Home}>
              <Redirect to={constUrlBase.phan_tich_thi_truong.url} />
            </Route>
          </Switch>
        </CommonMenu>
        <ModalViewZoom />
      </Router>
    </Provider>
  );
};



export default App;
